
function getCRMBaseUrl(organization) {
  if (organization.custom_domain) {
    return `${organization.custom_domain}`;
  }
  if (organization.type === 'force' && organization.instance_name) {
    return `https://${organization.instance_name}.salesforce.com/`;
  }
  if (organization.type === 'azure') {
    return organization.resource_url;
  }
  if (organization.type === 'hubspot') {
    return 'https://app.hubspot.com';
  }

  return null;
};

function getContactUrl(organization, contact) {
  let url = null;
  const crmBaseUrl = getCRMBaseUrl(organization);
  if (crmBaseUrl) {
    if (organization.type === 'azure') {
      const app = (organization?.dynamics_app_id)
        ? `appid=${organization.dynamics_app_id}`
        : 'app=d365default';
      url = `${crmBaseUrl}/main.aspx?${app}&forceUCI=1&pagetype=entityrecord&etn=contact&id=${contact.contact_id}`;
    } else if (organization.type === 'force') {
      url = `${crmBaseUrl}/${contact.contact_id}`;
    } else if (organization.type === 'hubspot') {
      const organizationId = organization.organization_id.substring(3, organization.organization_id.length);
      url = `${crmBaseUrl}/contacts/${organizationId}/contacts/${contact.contact_id}`;
    }
  }
  return url;
}

function getAccountUrl(organization, account) {
  let url = null;
  const crmBaseUrl = getCRMBaseUrl(organization);
  if (crmBaseUrl) {
    if (organization.type === 'azure') {
      const app = (organization?.dynamics_app_id)
        ? `appid=${organization.dynamics_app_id}`
        : 'app=d365default';
      url = `${crmBaseUrl}/main.aspx?${app}&forceUCI=1&pagetype=entityrecord&etn=account&id=${account.account_id}`;
    } else if (organization.type === 'force') {
      url = `${crmBaseUrl}/${account.account_id}`;
    } else if (organization.type === 'hubspot') {
      // delete 'hs-' in organization_id
      const organizationId = organization.organization_id.substring(3, organization.organization_id.length);
      url = `${crmBaseUrl}/contacts/${organizationId}/company/${account.account_id}`
    }
  }
  return url;
}

function getOpportunityUrl(organization, opportunity) {
  let url = null;
  const crmBaseUrl = getCRMBaseUrl(organization);
  if (crmBaseUrl) {
    if (organization.type === 'azure') {
      const app = (organization?.dynamics_app_id)
        ? `appid=${organization.dynamics_app_id}`
        : 'app=d365default';
      url = `${crmBaseUrl}/main.aspx?${app}&forceUCI=1&pagetype=entityrecord&etn=opportunity&id=${opportunity.opportunity_id}`;
    } else if (organization.type === 'force') {
      url = `${crmBaseUrl}/${opportunity.opportunity_id}`;
    } else if (organization.type === 'hubspot') {
      const organizationId = organization.organization_id.substring(3, organization.organization_id.length);
      url = `${crmBaseUrl}/contacts/${organizationId}/deal/${opportunity.opportunity_id}`;
    }
  }
  return url;
}

function getOwnerUrl(organization, owner) {
  let url = null;
  const crmBaseUrl = getCRMBaseUrl(organization);
  if (crmBaseUrl) {
    if (organization.type === 'azure') {
      const targetApp = (organization?.dynamics_app_id)
        ? `appid=${organization.dynamics_app_id}`
        : 'app=d365default';
      url = `${crmBaseUrl}/main.aspx?${targetApp}&forceUCI=1&pagetype=entityrecord&etn=systemuser&id=${owner.user_id}`;
    } else if (organization.type === 'force') {
      url = `${crmBaseUrl}/${owner.user_id}`;
    }
    // Untested, might be the wrong user id, only leads to the permission edit page anyways
    // else if (organization.type === 'hubspot') {
    //   url = `${crmBaseUrl}/settings/${organization.organization_id.substring(3, organization.organization_id.length)}/users/editUser/${owner.user_id}`;
    // }
  }
  return url;
}

function makeProcessCellCallback() {
  return (params, organization) => {
    const colDef = params.column.getColDef();
    const exportURLType = colDef.cellRendererParams?.exportURLType;

    if (
      exportURLType
    ) {
      let url = null;
      if (exportURLType === 'opportunity') {
        url = getOpportunityUrl(organization, params.node?.data);
      } else if (exportURLType === 'account') {
        url = getAccountUrl(organization, params.node?.data);
      } else if (exportURLType === 'owner') {
        const field = colDef.field;
        if (field === 'account.owner.name') {
          url = getOwnerUrl(organization, params.node?.data?.account?.owner || params.node?.data);
        } else {
          url = getOwnerUrl(organization, params.node?.data?.owner || params.node?.data);
        }
      } else if (exportURLType === 'contact') {
        url = getContactUrl(organization, params.node?.data);
      }
      if (url && params.value && organization.export_crm_urls) {
        return `=HYPERLINK("${url}", "${params.value.split("\"").join('""')}")`;
      }
      return params.value;
    }
    return params.value;
  };
}


module.exports = {
  getOwnerUrl,
  getOpportunityUrl,
  getAccountUrl,
  getContactUrl,
  getCRMBaseUrl,
  makeProcessCellCallback,
};
